import { render, staticRenderFns } from "./TripTemplates.vue?vue&type=template&id=7b616838&scoped=true&"
import script from "./TripTemplates.vue?vue&type=script&lang=js&"
export * from "./TripTemplates.vue?vue&type=script&lang=js&"
import style0 from "./TripTemplates.vue?vue&type=style&index=0&id=7b616838&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b616838",
  null
  
)

/* custom blocks */
import block0 from "./TripTemplates.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports